import { faEdit, faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type CellContext } from '@tanstack/react-table';
import { useIntl } from 'react-intl';

import {
    GATEWAY,
    type ParkingGateways,
} from 'src/features/parkingManagement/api/ParkingGatewayAPIs/useParkingGateways.ts';
import { parkingManagementMessages } from 'src/features/parkingManagement/utils';
import { Button } from 'src/registry/ui/Button.tsx';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip.tsx';
import { generalMessages } from 'src/utils/messages.ts';

//TODO: add permissions for edit/delete exit/entrance point

interface CellEntryExitPointsActionsProps<TData, TValue> extends CellContext<TData, TValue> {
    deleteCallback: (point: TData) => void;
    editCallback: (point: TData) => void;
}
function CellEntryExitPointsActions({
    deleteCallback,
    editCallback,
    row,
}: CellEntryExitPointsActionsProps<ParkingGateways, unknown>) {
    const { formatMessage } = useIntl();

    const point = row.original.gateway_type;
    const toolTipDisplay =
        point === GATEWAY.ENTRY ? parkingManagementMessages.entrance : parkingManagementMessages.exit;

    return (
        <div className="ml-auto flex max-w-24 gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            onClick={() => editCallback(row.original)}
                            size="icon"
                            variant="link"
                            // disabled={!disableActionButton(row.original)}
                        >
                            <FontAwesomeIcon icon={faEdit} />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        {`${formatMessage(generalMessages.edit)} ${formatMessage(toolTipDisplay).toLocaleLowerCase()}`}
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            onClick={() => deleteCallback(row.original)}
                            size="icon"
                            variant="link"
                            // disabled={!disableActionButton(row.original)}
                        >
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        {`${formatMessage(generalMessages.delete)} ${formatMessage(toolTipDisplay).toLocaleLowerCase()}`}
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}

export { CellEntryExitPointsActions };
